import React from 'react';
/*import LoggedInPage from '../../views/core/LoggedInPage';*/
import PreLoginPage from '../../views/core/PreLoginPage';
import UserStorageUtil from '../../util/UserStorageUtil';
import NativeAjax from '../../util/NativeAjax';
import HmAjax from '../../util/HmAjax';
import $ from 'jquery';
import HmEventRegistry from '../../model/HmEventRegistry';
import TestTakingModalComponent from '../../views/plp/TestTakingModalComponent';
import Errmsg from './Errmsg';

export default class MozartView extends PreLoginPage {

	constructor(props) {
		super(props);
		this.trackId = null;
		this.userId = null;
		this.trackLessonClose = this.trackLessonClose.bind(this);
		this.enableTimer = true;

		this.state = {
			lessonLoaded: false
		}

		this.lessonUrlBase = this.getUrlFor("MOZART_LESSON_URL");
		this.lessonId = this.props.match.params.lid;

		this.substituteZAProxy = this.substituteZAProxy.bind(this);

		this.errorText = "error"; // Default Error Text message

		this.lessonUrl = this.lessonUrlBase.replace("#lessonId", this.lessonId);
		window.pageId = this.lessonId;
		window.pageXML_request = this.lessonUrlBase;
		window.selectedPageid = this.lessonId;
	}

	substituteZAProxy(lessonUrl){
		if(lessonUrl && lessonUrl.length > 0){
			lessonUrl = lessonUrl.replace(this.getUrlFor("ORIG_CS_BASE_URL"),this.getUrlFor("CS_BASE_URL"));
			//for audio
			lessonUrl = lessonUrl.replace(this.getUrlFor("ORIG_CS_BASE_URL"),this.getUrlFor("CS_BASE_URL"));
		}

		return lessonUrl;
	}

	componentDidMount() {
		let me = this;


		let success = (pageXML) => {
			if (pageXML && !pageXML.error && pageXML.xmlResponse) {
				if (!me.checkError(pageXML.xmlResponse)) {
					me.setState({
						lessonLoaded: true
					});
					
					//substitute proxy URL
					pageXML.xmlResponse = me.substituteZAProxy(pageXML.xmlResponse);

					me.loadMozart(pageXML.xmlResponse);
				} else {

				}
				//pageXML = "<page>  <page_id>chep10063_sa101</page_id>  <name>Diffusion and Brownian Motion</name><content_type>animated_unit</content_type>  <group label='Slider'><video_url>http://local.heyscience.com:3000/stub/mozarts/chep10063_sa101.swf</video_url><type>slider</type><audio_url>http://local.heyscience.com:3000/stub/mozarts/chep10063_sa101_audio_en.swf</audio_url></group></page>";
			}
		}

		let failure = (resp) => {
			console.error("Error Occurred ::", resp);

			if (resp && resp.status == "404") {
				me.errorText = "resource.404.message";
			} else if (resp && resp.status == "403") {
				me.errorText = "resource.403.message";
			} else {
				me.errorText = "503.title";
			}

			me.showError();
		}

		let lessonUrl = me.lessonUrl.replace("#lessonId", me.lessonId);

		new NativeAjax(lessonUrl).enableCORS().get(success, failure);
	}

	showError() {
		this.showAlert(this.rb("error"), this.rb(this.errorText));
	}

	checkError(xmlResponse) {
		let me = this;
		let error = true;
		try {
			let video_url = (xmlResponse && $(xmlResponse).find("video_url")) ? $(xmlResponse).find("video_url").text() : "";
			if (video_url && video_url.length > 0) {
				error = false;
			} else {
				if ($(xmlResponse).find("error")) {
					console.error($(xmlResponse));

					if (xmlResponse && xmlResponse.indexOf("404") > 0) {
						me.errorText = "resource.404.message";
					} else if (xmlResponse && xmlResponse.indexOf("403") > 0) {
						me.errorText = "resource.403.message";
					}

					me.showError();
				}
			}
		} catch (e) {
			console.error(e);
		}

		return error;
	}
	initiateTimer() {
		var me = this;
		setInterval(() => {
			if (me.enableTimer) {
				//console.log("initiateTimer ::");
				me.trackLessonClose();
			}
		}, 5000);
	}

	loadMozart(pageXML) {
		let me = this;
		$.ajax({
			url: window.mozartTemplateLocation || "/mozart/HeyScience.html",
			dataType: "text",
			cache: false,
			success: function (data) {
				//window.removeLoading();

				// for tracking
				/*if($.trim(lessonName)=="") {
					selectedLessonId = search_sellessonid;
					selectedLessonName = search_sellessonname;
					selectedCategory = search_selCategory;
				}
				else
				{			
					selectedLessonId = $(myPageList).attr("ID");
					if(selectedLessonId == undefined || selectedLessonId == null)
					{
						selectedLessonId = "null";
						selectedLessonName = "null";
						selectedCategory = selectedcategory;
					}else{
						selectedLessonName = $(myPageList).attr("label");
						selectedCategory = "Lesson";
					}	
				}*/

				var playerContainer = $("#playerHTML");
				$(playerContainer).css({
					top: 0,
					width: "100%",
					height: "100%",
					position: "absolute",
					zIndex: 10001
				});
				$(playerContainer).html(data);
				//$("body").append(playerContainer);
				if (typeof window.loadPlayer === "function") {
					window.loadPlayer(pageXML);
		

					let bridgeLoadAttempt = 0;
					setTimeout(function () {
						let bridgeLoader = setInterval(function () {
							if (window.isPlayerLoaded || (bridgeLoadAttempt > 10)) {
								console.log("Interval Cleared");
								//new HmAjax(this.getUrlFor("TRACK_LESSON_CLOSE") + me.trackId + "/" + me.userId).get(successHandler, failureHandler);
								clearInterval(bridgeLoader);
								me.trackLessonOpen();
								me.initiateTimer();
							} else {
								console.log("waiting to load....");
								window.bridgeLoaded();
								//new HmAjax(this.getUrlFor("TRACK_LESSON_OPEN"), formData).post(successHandler, failureHandler);
							}
							bridgeLoadAttempt++;
						}, 200);
					}, 500);

					//SP added
					if (window.isPlayerLoaded){
						me.trackLessonOpen();
						me.initiateTimer();
					}

					//setTimeout(function(){if(!window.isPlayerLoaded) {window.bridgeLoaded();}},2000);
				}


				/*let pageName = window.pageName;
				let lessonName = window.lessonName;
				
				///eval("loadPlayer(pageXML)");
				//var headerString = lessonName+" - "+pageName;
				var headerString = pageName;
				if(window.$.trim(lessonName)=="") {
					headerString = pageName;
				}
				window.setPlayerHeader(headerString);

				if(window.myPageList!=null) {
					window.setLeftPanel(window.$(window.myPageList),lessonName);
				}
				*/
				//$("#playerHTML").jScrollPane({autoReinitialise: true});

			},
			error: function () {
				//removeLoading();
			}
		});

		this.userId = this.getUser().getUserId();
	}
	
	trackLessonClose() {
		alert('tracking lesson closes....');
		try {
			var me = this;

			var successHandler = function (data) {
				console.log("track lesson close success");
			}

			var failureHandler = function (err) {
				console.log("Error in TRACK_LESSON_CLOSE");
				return;
			}
			new HmAjax(this.getUrlFor("TRACK_LESSON_CLOSE") + me.trackId + "/" + me.userId).get(successHandler, failureHandler);
		} catch (e) {
			console.log("Error in track lessson close..");
		}
	}
	getAllParamsObj(){
		var paramObj = {};
		try{
			var paramsArr = window.location.href.split("?");
			if(paramsArr.length > 1 && paramsArr[1].length > 0){
				paramObj = this.extractParamsObj(paramsArr[1]);			   
			}
		}catch(e){}

		return paramObj;
	}
	getAllUrlParams(urlString){
		try{
			var paramsArr = window.location.href.split("?");
			if(paramsArr.length > 1 && paramsArr[1].length > 0){
				if(urlString.indexOf("?") > 0){
					urlString += "&"+paramsArr[1];
				}else{
					urlString += "?"+paramsArr[1];
				}
			}
		}catch(e){}

		return urlString;
	}

	extractParamsObj(paramsArrStr){
		var paramObj = {};
		try{
			if(paramsArrStr !== null && paramsArrStr.length > 0){
				var paramPairArr = paramsArrStr.split("&");
				if(paramPairArr !== null && paramPairArr.length > 0){
					for(var i=0; i < paramPairArr.length; i++){
						var eachPair = paramPairArr[i].split("=");
						paramObj[eachPair[0]] = (eachPair.length > 0) ? eachPair[1] : eachPair[0];
					}
				}
			}
		}catch(e){}

		return paramObj;
	}	
	trackLessonOpen() {
		alert('tracking lesson open....');
		var params = this.getAllParamsObj();
		/*lessonPref:"html5"
		lessonname:"Subtracting%207-Digit%20Numbers"
		revisiontopicid:"0"
		src:"plp"
		testid:"0"
		url:"vl1283a_subtract7digit"*/
		var formData = {
			"lessonUrl": params.url,
			"lessonDd": params.dd,
			"lessonType": params.lessonPref,
			"classId": parseInt(params.classId),
			"accessId": parseInt(params.accessId),
			"topicSubtopicMapId": parseInt(params.revisiontopicid)
		}

		try {
			var me = this;
			var successHandler = function (data) {
				if (data != null) {
					console.log("open: " + me.trackId + "...."+data.trackId);
					me.trackId = data.trackId;
					return;
				}

			}

			var failureHandler = function (err) {
				console.log("Error in TRACK_LESSON_OPEN");
				return;
			}
			var lessonId = this.props.match.params.id;

			new HmAjax(this.getUrlFor("TRACK_LESSON_OPEN"), formData).post(successHandler, failureHandler);
		} catch (e) {
			console.log("Error in lesson tracking...");
		}

		try {
			var trackObj = {
				"lesson_id": parseInt(params.lessonidTracking),
				"lesson_dd": parseInt(params.dd) || 1,
				"source": this.getTracker().enums.lessonSource[params.tracksource],
				"source_id": parseInt(params[params.tracksource == "subtopic" ? "revisiontopicid" : "testid"]),
				"snippet_id": parseInt(params.snid) || 0,
				"question_source": params.qsrc || 0
			}

			this.initiateTrack("lesson_opened", trackObj);
		} catch (e) {}
	}
	render() {
		if (this.state.lessonLoaded) {
			return ( <div id = "playerHTML" ></div>
			);
		} else {
			return super.render();
		}
	}
	

}


// WEBPACK FOOTER //
// ./src/views/lesson/MozartView.js